var $ = global.jQuery = global.$;

//slidea stuff
require('../third-party/slidea/assets/js/velocity/velocity');
require('../third-party/slidea/assets/js/velocity/velocity.ui');
require('../third-party/slidea/assets/js/imagesLoaded/imagesLoaded');
require('../third-party/slidea/assets/js/hammer/hammer');
require('../third-party/slidea/assets/js/mousewheel/mousewheel');
require('../third-party/slidea/assets/js/youtube/youtube');
require('../third-party/slidea/assets/js/vimeo/vimeo');
require('../third-party/slidea/assets/js/animus/animus');
require('../third-party/slidea/assets/js/slidea/slidea');
require('../third-party/slidea/assets/js/slidea/layouts/slidea.default');
require('../third-party/jquery.matchHeight-min');
var _Base = require('./_Base');

 /**
  * @extends Base widget
  * @class
  */
var HomeSlider_PTS = _Base.extend(
  /** @lends _Base.prototype */
  {
    init: function () {
      $('.home-content-slider-block').matchHeight(
        {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        }
      );

      this.$el.slidea({
        animation: {
            initial: 'opacity 0',                   // Slide initial animation state
            out: 'fade out',                        // Slide default out animation
            easing: 'swing',                        // Default animation easing
            duration: 500                           // Default animation duration
        },

        delay: 4000,                                // Slide delay / display time
        start: 800,                                 // Layer animation start time

        layout: 'default',                          // Slider layout
        layerIndex: 99,                             // Starting z-index for layers

        touch: true,                                // Slider touch controls

        retina: true,                               // Retina images with @2x suffix

        autoplay: false,                             // Autoplay feature
        pauseOnHover: false,                        // Pause autoplay on hover
        loop: true,                                 // Start from first slide after reaching last

        progress: true,                             // Add progress bar
        progressPosition: 'bottom',                 // Progress bar position top / bottom
        progressClass: 'slidea-progress-light',     // Additional thumbnail classes

        controls: true,                             // Add next / prev buttons
        controlsThumbnail: true,                    // Add thumbnail to controls
        controlsHTML: {
            prev: '&lt;',
            next: '&gt;'
        },
        controlsClass: 'slidea-controls-alternate', // Additional control classes

        mousewheel: false,                          // Enable Slide on Scroll
        preventScrolling: true,                     // Prevent page scrolling if mousewheel enabled

        pagination: true,                          // Add pagination
        paginationPosition: 'inside',               // Pagination position outside / inside
        paginationClass: 'slidea-pagination-light', // Additional pagination classes

        scroller: true,                            // Enable Scroller Item
        scrollerMarkup: '<span class="slidea-scroller-1"></span>', // Markup for scroller item (1 or 2)
        scrollerPosition: 'center',                 // Scroller position: left, center, right
        scrollerTop: 80,                            // Percentage from top of slider

        responsiveFont: true,                       // Resize font responsively
        responsiveFontMax: 9999,                    // Maximum font ratio
        responsiveFontMin: 0.2,                     // Minimum font ratio

        preventDragging: true,                      // Prevent image dragging
      });
    }
});
module.exports = HomeSlider_PTS;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/HomeSlider_PTS.js
 ** module id = 262
 ** module chunks = 1
 **/